import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { Subscription } from 'rxjs/Subscription';
import { Autenticacion } from './../../../../resources/to/autenticacion';

@Component({
  selector: 'app-contenedor',
  templateUrl: './contenedor.component.html',
  styleUrls: ['./contenedor.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ContenedorComponent implements OnInit {

  public subscriptionMessages: Subscription;
  public autenticacion: Autenticacion;
  public routerLinkActive: string;
  public showBackButton: boolean = true;

  private ideRequest: string = '';

  constructor(
    private router: Router,  	
    private _sessionStorage: SessionStorageService
  ) { }

  ngOnInit() {
    this.ideRequest = localStorage.getItem('ideRequest');
  }

  public closeSession() {
    this._sessionStorage.clear('AUTENTICACION');
    this.router.navigate(['/recuperar-cuenta/autenticacion']);
  }

  redirectLogin() {
    const queryParam = this.ideRequest ? this.ideRequest : '';
    this.router.navigate(['/'], { queryParams: { ideRequest: queryParam }});
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/contenedor/contenedor.component.ts